import type { AppStartListening } from "@/data/listenerMiddleware";
import { reattemptWindowEndDateListener } from "@/stores/listeners/socratic-listeners/reattempt-window-end-date-listener";

import { preparationEndDateListener } from "./preparation-end-date-listener";
import { recordingStartCutoffDateListener } from "./recording-start-cutoff-date-listener";
import { responseEndDateListener } from "./response-end-date-listener";

/**
 * Start all Socratic dialogue timer listeners.
 */
export function startSocraticTimerListeners(startListening: AppStartListening) {
  preparationEndDateListener(startListening);
  responseEndDateListener(startListening);
  reattemptWindowEndDateListener(startListening);
  recordingStartCutoffDateListener(startListening);
}
